import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

export const muiAppBarSx = (hideTopNavi: boolean, greaterThanWindowLarge: boolean): SxProps<Theme> => ({
        mt: hideTopNavi ? 0 : greaterThanWindowLarge ? 13 : 0,
        height: {xs: 70, lg: 72},
        display: "flex",
        paddingLeft: "0!important",
        paddingRight: "0!important",
        paddingTop: 0,
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
        backgroundColor: "var(--background-white)",
        color: (theme) => theme.palette.text.primary,
        boxShadow: "none",
        borderTop: "1px solid #e0e0e0",
        borderBottom: "1px solid #e0e0e0",
});

export const arrowBoxSx = (
    isActive: boolean,
    theme: Theme
): SxProps<Theme> => ({
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: isActive
        ? "none"
        : `6px solid ${theme.palette.text.primary}`,
    borderBottom: isActive
        ? `6px solid ${theme.palette.primary.contrastText}`
        : "none",
    transition: "transform 0.2s",
});


export const toolbarButtonSx: SxProps<Theme> = {
    display: "block",
    position: "relative",
    whiteSpace: "nowrap",
    flexShrink: 1,
    minWidth: 0,
    paddingX: 2,
    "&::after": {
        content: '""',
        position: "absolute",
        left: "0",
        right: "0",
        bottom: "-4px",
        height: "4px",
        marginX: "auto",
        width: "calc(100% - 16px)",
        backgroundColor: (theme) => theme.palette.primary.main,
        transform: "scaleX(0)",
        visibility: "hidden",
        transition: "visibility 0s linear 0.3s, transform 0.3s",
    },
    "&:hover": {
        background: "none",
    },
};

export const toolbarButtonHoveredSx: SxProps<Theme> = {
    display: "block",
    position: "relative",
    whiteSpace: "nowrap",
    flexShrink: 1,
    minWidth: 0,
    paddingX: 2,
    background: "none",
    "&::after": {
        content: '""',
        position: "absolute",
        left: "0",
        right: "0",
        bottom: "-4px",
        height: "4px",
        marginX: "auto",
        width: "calc(100% - 16px)",
        backgroundColor: (theme) => theme.palette.primary.main,

        transform: "scaleX(1)",
        visibility: "visible",
        transition: "transform 0.3s",
    },
    "&:hover": {
        background: "none",
    },
};

export const desktopMenuSx: SxProps<Theme> = {
    display: {xs: "none", lg: "flex"},
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 3,
    height: "72px",
};

export const quickAccessButtonSx: SxProps<Theme> = {
    display: "flex",
    justifyContent: "flex-end",
    width: {lg:"138px", xl:"210px"},
    whiteSpace: "nowrap"
};

export const mobileMenuButtonSx: SxProps<Theme> = {
    paddingX: 4,
    "&:hover": {
        background: "none",
    },
};

export const iconButtonSx = (
    isKeyboardFocused: boolean,
    isActive: boolean,
    theme: Theme
): SxProps<Theme> => ({
    visibility: isKeyboardFocused ? "visible" : "visible",
    opacity: isKeyboardFocused ? 1 : 0,
    transform: isKeyboardFocused ? "scale(1)" : "scale(0)",
    transition: "opacity 0.1s ease, transform 0.1s ease",
    marginLeft: "4px",
    width: isKeyboardFocused ? "24px" : "1px",
    height: isKeyboardFocused ? "24px" : "1px",
    borderRadius: "4px",
    backgroundColor: isActive ? theme.palette.primary.main : "var(--background-grey)",
    padding: 0,
    "&:focus": {
        outline: "revert",
        visibility: "visible",
        opacity: 1,
        transform: "scale(1)",
    },
});

export const menuItemBoxSx = (isFlyoutSmall: boolean, theme: any) => ({
    flexGrow: 1,
    width: isFlyoutSmall ? "350px" : "33%",
    maxWidth: isFlyoutSmall ? "300px" : undefined,
    padding: "0 28px 0 32px",
    "& .openNew": {
        color: theme.palette.primary.main,
    },
});

export const menuItemSx = (theme: any) => ({
    padding: 0,
    minHeight: "47px !important",
    whiteSpace: "normal",
    "&:hover": {
        color: theme.palette.primary.main,
        background: "none",
    },
});

export const menuItemHoveredSx = (theme: any) => ({
    padding: 0,
    minHeight: "47px !important",
    color: theme.palette.primary.main,
    whiteSpace: "normal",
    "&:hover": {
        background: "none",
    },
});


export const popoverSx = (isFlyoutSmall: boolean, hoveredTopMenuItemLeftPosition: number | string) => ({
    width: '100%!important',
    maxWidth: 'xl',
    paddingX: {
        lg: 2,
        xl: 'auto'
    },
    ".MuiPopover-paper": {
        position: "fixed",
        display: "flex",
        left: isFlyoutSmall ? hoveredTopMenuItemLeftPosition : 0,
        flexDirection: "row",
        flexWrap: "nowrap",
        width: isFlyoutSmall ? "350px" : "100%",
        minHeight: isFlyoutSmall ? 0 : 503,
        maxHeight: "100%",
        padding: "24px 0",
        borderRadius: 0,
        boxShadow: "0px 4px 18px 3px #0000001F",
    },
});